import React from 'react';

interface TurnoversSectionProps {
  onWeStoleBall: () => void;
  onWeTurnover: () => void;
  onTheyStoleBall: () => void;
  onTheyTurnover: () => void;
  actionFeedback?: string | null;
  theyTurnoverDisabled?: boolean;
}

const TurnoversSection: React.FC<TurnoversSectionProps> = ({
  onWeStoleBall,
  onWeTurnover,
  onTheyStoleBall,
  onTheyTurnover,
  actionFeedback,
  theyTurnoverDisabled = false,
}) => (
  <div className="z-10">
    <div className="flex w-full justify-between my-4">
      <div className="w-1/2 text-center text-xl font-bold">Us</div>
      <div className="w-1/2 text-center text-xl font-bold">Them</div>
    </div>
    <div className="flex w-full gap-6 z-10 px-3">
      <div className="flex-1 items-center flex flex-col gap-5">
        <button
          className="w-full bg-[#7fe526] text-black font-bold rounded-lg py-3 px-3 text-xl md:text-2xl shadow-md transition-all"
          onClick={onWeStoleBall}
        >
          CAUSED TURNOVER
        </button>
        <button
          className="w-full bg-[#7fe526] text-black font-bold rounded-lg py-3 px-3 text-xl md:text-2xl shadow-md transition-all"
          onClick={onWeTurnover}
        >
          TURNOVER
        </button>
      </div>
      <div className="flex-1 items-center flex flex-col gap-5">
        <button
          className="w-full bg-[#294e87] text-white font-bold rounded-lg py-3 px-3 text-xl md:text-2xl shadow-md transition-all"
          onClick={onTheyStoleBall}
        >
          CAUSED TURNOVER
        </button>
        <button
          className={`w-full font-bold rounded-lg py-3 px-3 text-xl md:text-2xl shadow-md transition-all ${
            actionFeedback === 'THEM_TURNOVER' ? 'bg-white text-black' : 'bg-[#294e87] text-white'
          } ${theyTurnoverDisabled ? 'opacity-60 cursor-not-allowed' : ''}`}
          onClick={onTheyTurnover}
          disabled={theyTurnoverDisabled}
        >
          TURNOVER
        </button>
      </div>
    </div>
  </div>
);

export default TurnoversSection;
